/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const addressTranslations = {
  streetAddress: {
    label: "Straße und Hausnummer",
  },
  postalCode: {
    label: "PLZ",
  },
  addressLocality: {
    label: "Ort",
  },
  postOfficeBoxNumber: {
    label: "Postfach",
  },
  postOfficeBoxPostalCode: {
    label: "Postfach PLZ",
  },
  postOfficeBoxAddressLocality: {
    label: "Postfach Ort",
  },
  addressAddition: {
    label: "Adresszusatz",
  }
};

export default addressTranslations;
